import { Checkbox, Text } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { ModalConfirm } from "@src/components/ui-kit";
import { observer, useLocalObservable } from "mobx-react-lite";

type MarkAsUnpaidConfirmProps = {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly onConfirm: (removeMatchedPayments: boolean) => Promise<unknown>;
  readonly hasMatchedPayments: boolean;
  readonly isProforma?: boolean;
  readonly isLoading?: boolean;
};

export const MarkAsUnpaidConfirm = observer(function MarkAsUnpaidConfirm({
  isOpen,
  onClose,
  onConfirm,
  hasMatchedPayments,
  isProforma = false,
  isLoading,
}: MarkAsUnpaidConfirmProps) {
  const state = useLocalObservable(() => ({
    removeMatchedPayments: true,
    setRemoveMatchedPayments(value: boolean) {
      this.removeMatchedPayments = value;
    },
    reset() {
      this.removeMatchedPayments = true;
    },
  }));

  const handleClose = () => {
    state.reset();
    onClose();
  };

  return (
    <ModalConfirm
      heading={t`Mark as unpaid`}
      confirmBtnTitle={t`Mark as unpaid`}
      destructive
      isOpen={isOpen}
      isLoading={isLoading}
      onClose={handleClose}
      onConfirm={() =>
        onConfirm(hasMatchedPayments ? state.removeMatchedPayments : false)
      }
    >
      <Text>
        <Trans>
          This will clear the paid date. The document will appear as unpaid.
        </Trans>
      </Text>
      {isProforma && (
        <Text mt="2">
          <Trans>Related proof of payment invoices will be deleted.</Trans>
        </Text>
      )}
      {hasMatchedPayments && (
        <Checkbox
          mt="4"
          isChecked={state.removeMatchedPayments}
          onChange={(e) => state.setRemoveMatchedPayments(e.target.checked)}
        >
          <Trans>Also remove matched bank payments</Trans>
        </Checkbox>
      )}
    </ModalConfirm>
  );
});
